import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { queryProcessApplyForm, getApplyProcessFormByFormId, formFillSave } from '@/services/processApply';
import selectPerson from '@/components/select-person';
export default {
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    var usersTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位成员',
      value: 5
    }];
    return {
      usersList: {},
      usersTabList: usersTabList,
      checkItem: {},
      formId: new Number(),
      formName: 'formName',
      activeKey: ['1'],
      processApplyFormLists: [],
      visible: false,
      jsonData: {
        "config": {
          "labelWidth": 100,
          "labelPosition": "right",
          "size": "small",
          "customClass": "",
          "ui": "antd",
          "layout": "horizontal",
          "labelCol": 3,
          "width": "100%",
          "hideLabel": false,
          "hideErrorMessage": false
        }
      }
    };
  },
  methods: {
    enterItem: function enterItem(formId) {
      var _this = this;
      getApplyProcessFormByFormId({
        formId: formId
      }).then(function (res) {
        if (res.data.code == 200) {
          if (res.data.data == null) {
            _this.$message.error('请设计表单后再发起申请');
            return;
          }
          _this.versionId = res.data.data.id;
          _this.jsonData = JSON.parse(res.data.data.formData.value);
          _this.$nextTick(function () {
            _this.$refs.generateForm.refresh();
          });
        }
      });
    },
    queryProcessApplyFormLists: function queryProcessApplyFormLists() {
      var _this2 = this;
      queryProcessApplyForm().then(function (res) {
        if (res.data.code == 200) {
          _this2.processApplyFormLists = res.data.data;
        }
      });
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      // 处理抄送数据

      // organData
      // actorId: 20000
      // actorName: "党委组织架构"

      // postData
      // actorId: (...)
      // actorName: (...)
      // organId: (...)

      // userData
      // actorId: (...)
      // actorName: (...)

      // copyType text,typeId_ text,userId text,organId text,

      var copyManData = new Array();
      var organData = this.usersList.organData.map(function (item) {
        return {
          copy_type: 2,
          type_id: '',
          organ_id: item.actorId,
          post_id: '',
          user_id: ''
        };
      });
      var postData = this.usersList.postData.map(function (item) {
        return {
          copy_type: 1,
          type_id: '',
          organ_id: item.organId,
          post_id: item.actorId,
          user_id: ''
        };
      });
      var userData = this.usersList.userData.map(function (item) {
        return {
          copy_type: 0,
          type_id: '',
          organ_id: '',
          post_id: '',
          user_id: item.actorId
        };
      });
      copyManData = [].concat(_toConsumableArray(postData), _toConsumableArray(organData), _toConsumableArray(userData));
      this.$refs.generateForm.getData().then(function (data) {
        formFillSave({
          formId: _this3.checkItem.formId,
          versionId: _this3.versionId,
          fillData: data,
          copyManData: copyManData
        }).then(function (res) {
          if (res.data.code == 200) {
            _this3.$message.success('保存成功');
            _this3.onClose();
          } else {
            _this3.$message.error(res.data.message);
          }
        });
      }).catch(function (e) {});
    }
  },
  created: function created() {
    this.formId = this.$route.query.formId;
    this.enterItem(this.formId);
  }
};